import { render, staticRenderFns } from "./TplBed.vue?vue&type=template&id=c11bb292"
import script from "./TplBed.vue?vue&type=script&lang=js"
export * from "./TplBed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontAgencies/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports